var _path, _circle, _circle2, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiBlushingFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC4D",
    d: "M36 18c0 9.941-8.059 18-18 18c-9.94 0-18-8.059-18-18C0 8.06 8.06 0 18 0c9.941 0 18 8.06 18 18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7892",
    cx: 29,
    cy: 22,
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7892",
    cx: 7,
    cy: 22,
    r: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#664500",
    d: "M29 14a.997.997 0 0 1-.707-.293c-2.577-2.575-7.055-1.736-7.099-1.726a.996.996 0 0 1-1.174-.787a.998.998 0 0 1 .783-1.174c.227-.046 5.563-1.065 8.903 2.273A.999.999 0 0 1 29 14zM7 14a.999.999 0 0 1-.707-1.707c3.34-3.341 8.678-2.318 8.903-2.273a1 1 0 0 1-.391 1.962c-.069-.015-4.529-.843-7.098 1.726A1 1 0 0 1 7 14zm19 5a.997.997 0 0 1-.707-.293c-1.304-1.305-4.09-.974-5.052-.736a1 1 0 0 1-.483-1.941c.186-.046 4.575-1.111 6.949 1.263A.999.999 0 0 1 26 19zm-16 0a.999.999 0 0 1-.707-1.707c2.373-2.373 6.764-1.309 6.95-1.263a1 1 0 0 1-.483 1.941c-.964-.237-3.749-.567-5.052.736A1.001 1.001 0 0 1 10 19z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#664500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 25s1 4 5 4s5-4 5-4s-1 1-5 1s-5-1-5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 29.5c-4.34 0-5.474-4.335-5.485-4.379a.501.501 0 0 1 .829-.485c.039.034 1.066.864 4.656.864c3.644 0 4.647-.855 4.657-.863a.513.513 0 0 1 .597-.06a.495.495 0 0 1 .231.544C23.474 25.165 22.34 29.5 18 29.5zm-4.051-3.492C14.526 27.072 15.724 28.5 18 28.5s3.475-1.428 4.051-2.492c-.82.258-2.101.492-4.051.492s-3.231-.234-4.051-.492zM13 25h.01H13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiBlushingFace);
export default __webpack_public_path__ + "static/media/emoji-blushing-face.69d5ff89b8080391b48927d7fe71796b.svg";
export { ForwardRef as ReactComponent };